
<div>
  <!-- Name -->
  <div class="row">
    <div class="col-12">
      <div class="label mt-2 mb-1">Name</div>
      <input type="text" class="form-control" v-model="occurrence.name" />
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <div class="label mt-2 mb-1">Diverted Flight</div>
      <button
        v-if="!divertedFlight"
        type="button"
        :disabled="addFlightsLoading"
        class="btn btn-block btn-sm btn-success mt-2 mb-2 d-flex justify-content-center align-items-center"
        @click="chooseDivertedFlight()"
      >
        <i class="far fa-plus mr-2" v-if="!addFlightsLoading"></i>
        <i class="far fa-spinner fa-spin mr-2" v-else></i>
        Choose Diverted Flight
      </button>
    </div>
  </div>

  <div v-if="divertedFlight">
    <table class="aog-table table table-striped">
      <colgroup>
        <col />
        <col />
        <col />
        <col />
        <col />
        <col />
        <col />
        <col style="width: 80px" />
      </colgroup>
      <thead>
        <tr>
          <th scope="col">Date</th>
          <th scope="col">Flight</th>
          <th scope="col">Operator</th>
          <th scope="col">Type</th>
          <th scope="col">Registration</th>
          <th scope="col">Departure</th>
          <th scope="col">Arrival</th>
          <th scope="col">Diverted To</th>
          <th scope="col" class="col-date">STD</th>
          <th scope="col" class="col-date">STA</th>
          <th scope="col">State</th>
          <th scope="col" class="remove-col"></th>
        </tr>
      </thead>
      <tbody>
        <tr class="" v-for="flight in occurrence.flights" :key="flight.id">
          <td>{{ flight.date | formatDateWithoutHours }}</td>
          <td>{{ flight.flightNo }}</td>
          <td>{{ flight.operator }}</td>
          <td>{{ flight.aircraftType }}</td>

          <td>{{ flight.aircraftRegistration }}</td>

          <td>{{ flight.departureAirport }}</td>
          <td>{{ flight.arrivalAirport }}</td>
          <td>
            <v-select
              style="width: 90px"
              :options="airports"
              label="iataCode"
              :clearable="false"
              :reduce="(airport) => airport.iataCode"
              placeholder="Select..."
              v-model="divertedFlight.diversionAirport"
              :disabled="occurrence.isCompleted || !userCanEdit"
            ></v-select>
          </td>

          <td>{{ flight.scheduledTimeOfDeparture | formatTime }}</td>
          <td>{{ flight.scheduledTimeOfArrival | formatTime }}</td>

          <td>{{ flight.flightState }}</td>
          <td>
            <i
              v-if="!occurrence.isCompleted && userCanEdit"
              class="so-flight-remove far fa-trash-alt cursor-pointer"
              v-b-tooltip.hover="'Remove flight'"
              v-on:click="removeFlight(flight)"
            ></i>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div v-if="divertedFlight">
    <!-- Aircraft && Airport -->
    <div class="row">
      <div class="col-4">
        <div class="mt-2 mb-2 p-1">
          <div class="label">
            Original Destination Info
            <a :href="stationInfo.sisPdfUrl" target="_blank">
              <i class="far fa-link"></i>
              SIS
            </a>
          </div>

          <div class="row mb-2">
            <div class="col-2">MRO</div>
            <div class="col-10">
              {{ stationInfo.mro || 'N/A' }}
            </div>
          </div>
        </div>
      </div>

      <div class="col-4">
        <div class="mt-2 mb-2 p-1">
          <div class="label">
            Diversion Destination Info
            <a :href="stationInfoDiv.sisPdfUrl" target="_blank">
              <i class="far fa-link"></i>
              SIS
            </a>
          </div>

          <div class="row mb-2">
            <div class="col-2">MRO</div>
            <div class="col-10">
              {{ stationInfoDiv.mro || 'N/A' }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="label mt-2 mb-1">Diversion Reason</div>
        <v-select
          :options="diversionReasons"
          label="name"
          :clearable="false"
          :reduce="(reason) => reason.id"
          placeholder="Please select a Reason..."
          v-model="occurrence.diversionReason"
          :disabled="occurrence.isCompleted || !userCanEdit"
        ></v-select>
      </div>
    </div>

    <div class="row" v-if="displayDiversionReasonRemarks">
      <div class="col-12">
        <div class="label mt-2 mb-1">Diversion Reason Remarks</div>
        <textarea-autosize
          class="form-control comment-textarea"
          style="padding-right: 30px"
          rows="3"
          placeholder=""
          v-model="occurrence.diversionReasonRemarks"
          :min-height="75"
          :disabled="occurrence.isCompleted || !userCanEdit"
        ></textarea-autosize>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-6">
        <div class="label mt-2 mb-1 d-flex justify-content-between align-items-center">
          <div>Diversion Start</div>
        </div>
        <board-item-date-picker
          :disabled="occurrence.isCompleted || !userCanEdit"
          v-model="occurrence.diversionStart"
        ></board-item-date-picker>
      </div>
      <div class="col-6">
        <div class="label mt-2 mb-1 d-flex justify-content-between align-items-center">
          <div>Diversion End (Estimated)</div>
        </div>
        <board-item-date-picker
          :disabled="occurrence.isCompleted || !userCanEdit"
          v-model="occurrence.diversionEndEstimated"
        ></board-item-date-picker>
      </div>
    </div>

    <div>
      <div class="label mt-2 mb-1">General remarks</div>
      <textarea-autosize
        class="form-control comment-textarea"
        style="padding-right: 30px"
        rows="3"
        placeholder=""
        v-model="occurrence.generalRemarks"
        :min-height="75"
        :disabled="occurrence.isCompleted || !userCanEdit"
      ></textarea-autosize>
    </div>
  </div>
  <hr />
  <div class="mt-2 justify-content-end d-flex" v-if="!occurrence.isCompleted">
    <div>
      <button class="btn btn-block btn-sm btn-success mt-2 mb-3" @click="saveChanges()">
        <i class="far fa-save"></i>
        Save Changes
      </button>
    </div>
  </div>

  <b-modal
    ref="addFlights"
    id="addFlights"
    body-class="modal-body-wo"
    hide-footer
    hide-header
    size="wide"
    title="Add Affected Flight"
    :no-enforce-focus="true"
  >
    <TechnicalOccurrenceFlightsSelector
      @flightSelected="flightSelected"
      @closeModal="closeModal"
      :mode="'diversion'"
    ></TechnicalOccurrenceFlightsSelector>
  </b-modal>
</div>
